<template>
    <div class="pos-relative">
            <div class="flex flex-col sm:flex-row wd-100p mg-t-40 check-card-outer">
              <!-- background: linear-gradient(135.15deg, #9C14F2 2.15%, #9627DD 65.39%, #B255EC 98.4%); -->
              <div :class="`md:w-1/3 sm:w-full pd-20 check-card-item check-code-${getCode()}`" style=" border-radius: 15px 0px 0px 15px;">
                <div class="tx-white tx-semibold mg-b-20">{{ title }}</div>
                <div class="d-flex">
                  <div class="wd-40p">
                    <img :src="propObj.newbie.avator" class="rounded-full shadow bg-white border-2 border-gray-200" />
                  </div>
                  <div class="wd-60p pd-l-10">
                    <div class="mg-b-10">
                      <div class="tx-color-04">Нэр:</div>
                      <!-- {{ propObj.newbie }} -->
                      <div class="tx-semibold tx-white">{{ getFullName(propObj.newbie) }}</div>
                    </div>
                    <div class="mg-b-10">
                      <div class="tx-color-04">Нэгж:</div>
                      <div class="tx-semibold tx-white">{{ propObj.newbie.depart.name }}</div>
                    </div>
                    <div class="mg-b-10">
                      <div class="tx-color-04">Албан тушаал</div>
                      <div class="tx-semibold tx-white">{{ propObj.newbie.position }}</div>
                    </div>
                    <!-- <div class="mg-b-10">
                      <div class="text-muted">Skype</div>
                      <div class="tx-semibold tx-white">Энд дарна уу</div>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="md:w-2/3 sm:w-full bg-white pd-20" style="border-radius: 0 15px 15px 0;">
                
                <div class="flex divide-x">
                  <div class="pd-r-10 mg-t-40 w-2/5">
                    <div class="mg-b-10">
                      <div class="text-muted">Төлөв</div>
                      <div v-if="propObj.newbie.status!=null" class="tx-semibold">{{ propObj.newbie.status.statusName }}</div>
                    </div>
                    <div class="mg-b-10">
                      <div class="text-muted">Имэйл хаяг:</div>
                      <div class="tx-semibold">{{ propObj.newbie.mail }}</div>
                    </div>
                    <div class="mg-b-10">
                      <div class="text-muted">Статус</div>
                      <div class="tx-semibold">{{propObj.newbie.isActive?'Ажиллаж байгаа':'Ажлаас гарсан'}}</div>
                    </div>
                    <div class="mg-b-10">
                      <div class="text-muted">Туршилт эхэлсэн огноо</div>
                      <div class="tx-semibold">{{ propObj.dueStartDate | moment('YYYY-MM-DD') }}</div>
                    </div>
                  </div>
                  <div class="pd-l-10 w-3/5">
                    <div class="mg-y-10 tx-semibold pd-l-10">Гүйцэтгэл</div>
                    <div class="pd-l-10">
                      <div class="">
                        <div class="mg-b-20" v-for="b in propObj.boxesSummary">
                          <div class="d-flex">
                            <div class="text-muted mg-b-10">{{ b.boxName }}</div>
                            <div class="mg-l-auto tx-semibold">{{b.doneCheckCount}}/{{ b.allCheckCount }}</div>
                          </div>
                          <div>
                            <div class="progress check-card-outer">
                              <div :class="`progress-bar check-card-item check-code-${b.code}`" :style="`width: ${b.progress}%`" role="progressbar"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pos-absolute r-40 t--15 rounded-20 bg-white pd-x-15 pd-y-5" style="box-shadow: 0px 4px 37.6px rgba(50, 47, 192, 0.1);">
              <div class="d-flex">
                <div class="text-muted">Туршилтын хугацаа:</div>
                <div class="tx-semibold pd-l-10">{{ propObj.dueDate | moment('YYYY-MM-DD') }}</div>
              </div>
            </div>
          </div>
</template>
<script>
export default {
  props:{
    title: {
      type: String,
      default: () => "Миний Buddy-лж буй ажилтан"
    },
    propObj:{
      type: Object,
      default: () => {}
    }
  },
  mounted(){
    //console.log('propObj', this.propObj)
  },
  methods:{
    getCode(){
      let rv;
      
      if(this.propObj.isActive){
        switch(true){
          case (this.propObj.newbieDays >= 0 && this.propObj.newbieDays < 2):
              rv = 0;
              break;
          case (this.propObj.newbieDays >= 2 && this.propObj.newbieDays < 8):
              rv = 7;
              break;
          case (this.propObj.newbieDays >= 8 && this.propObj.newbieDays < 31):
              rv = 30;
              break;
          case (this.propObj.newbieDays >= 31):
              rv = 60;
              break;
          default: break;
        }
      }else{
        rv='empty';
      }

      console.log('getCode', this.propObj.newbieDays, this.propObj.isActive, rv);

      return rv;
    },
    getFullName(b){
      let rv=b.firstName.toUpperCase();
      if(b.lastName!=undefined && b.lastName!=null && b.lastName!='' && b.lastName.length){
          rv= b.lastName.charAt(0).toUpperCase() + '. ' +b.firstName;
      }
      return rv;
    },
  }
}
</script>